export enum RiskActionType {
  ControlAction = 'controlAction',
}

export enum RiskActionStatus {
  ToDo = 'toDo',
  Done = 'done',
  Cancelled = 'cancelled',
}

export enum EvidenceAttachmentKind {
  File = 'file',
  Document = 'document',
}

export const RISK_ACTIONS_URL = '/api/risks/actions/';
